"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITerminaltxnPaymentmethod = exports.ITerminaltxnFrozen = exports.ITerminaltxnInactive = exports.ITerminaltxnReserved = exports.ITerminaltxnStatus = exports.ITerminaltxnCountry = exports.ITerminaltxnReceipt = exports.ITerminaltxnPos = exports.ITerminaltxnUnattended = exports.ITerminaltxnPin = exports.ITerminaltxnSignature = exports.ITerminaltxnEmv = exports.ITerminaltxnSwiped = exports.ITerminaltxnCvvstatus = exports.ITerminaltxnOrigin = exports.ITerminaltxnEntrymode = exports.ITerminaltxnTerminalcapability = exports.ITerminaltxnFundingcurrency = exports.ITerminaltxnCurrency = exports.ITerminaltxnType = void 0;
var ITerminaltxnType;
(function (ITerminaltxnType) {
    ITerminaltxnType[ITerminaltxnType["CREDIT_CARD_ONLY_SALE_TRANSACTION_1"] = 1] = "CREDIT_CARD_ONLY_SALE_TRANSACTION_1";
    ITerminaltxnType[ITerminaltxnType["CREDIT_CARD_ONLY_REVERSE_AUTHORIZATION_4"] = 4] = "CREDIT_CARD_ONLY_REVERSE_AUTHORIZATION_4";
    ITerminaltxnType[ITerminaltxnType["CREDIT_CARD_ONLY_REFUND_TRANSACTION_5"] = 5] = "CREDIT_CARD_ONLY_REFUND_TRANSACTION_5";
    ITerminaltxnType[ITerminaltxnType["BATCH_OUT_TERMINAL_13"] = 13] = "BATCH_OUT_TERMINAL_13";
})(ITerminaltxnType = exports.ITerminaltxnType || (exports.ITerminaltxnType = {}));
var ITerminaltxnCurrency;
(function (ITerminaltxnCurrency) {
    ITerminaltxnCurrency["UNITED_ARAB_EMIRATES_DIRHAM_AED"] = "AED";
    ITerminaltxnCurrency["AFGHAN_AFGHANI_AFN"] = "AFN";
    ITerminaltxnCurrency["ALBANIAN_LEK_ALL"] = "ALL";
    ITerminaltxnCurrency["ARMENIAN_DRAM_AMD"] = "AMD";
    ITerminaltxnCurrency["NETHERLANDS_ANTILLEAN_GUILDER_ANG"] = "ANG";
    ITerminaltxnCurrency["ANGOLAN_KWANZA_AOA"] = "AOA";
    ITerminaltxnCurrency["ARGENTINE_PESO_ARS"] = "ARS";
    ITerminaltxnCurrency["AUSTRALIAN_DOLLAR_AUD"] = "AUD";
    ITerminaltxnCurrency["ARUBAN_FLORIN_AWG"] = "AWG";
    ITerminaltxnCurrency["AZERBAIJANI_MANAT_AZN"] = "AZN";
    ITerminaltxnCurrency["BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK_BAM"] = "BAM";
    ITerminaltxnCurrency["BARBADOS_DOLLAR_BBD"] = "BBD";
    ITerminaltxnCurrency["BANGLADESHI_TAKA_BDT"] = "BDT";
    ITerminaltxnCurrency["BULGARIAN_LEV_BGN"] = "BGN";
    ITerminaltxnCurrency["BAHRAINI_DINAR_BHD"] = "BHD";
    ITerminaltxnCurrency["BURUNDIAN_FRANC_BIF"] = "BIF";
    ITerminaltxnCurrency["BERMUDIAN_DOLLAR_BMD"] = "BMD";
    ITerminaltxnCurrency["BRUNEI_DOLLAR_BND"] = "BND";
    ITerminaltxnCurrency["BOLIVIANO_BOB"] = "BOB";
    ITerminaltxnCurrency["BOLIVIAN_MVDOL_BOV"] = "BOV";
    ITerminaltxnCurrency["BRAZILIAN_REAL_BRL"] = "BRL";
    ITerminaltxnCurrency["BAHAMIAN_DOLLAR_BSD"] = "BSD";
    ITerminaltxnCurrency["BHUTANESE_NGULTRUM_BTN"] = "BTN";
    ITerminaltxnCurrency["BOTSWANA_PULA_BWP"] = "BWP";
    ITerminaltxnCurrency["BELARUSIAN_RUBLE_BYN"] = "BYN";
    ITerminaltxnCurrency["BELIZE_DOLLAR_BZD"] = "BZD";
    ITerminaltxnCurrency["CANADIAN_DOLLAR_CAD"] = "CAD";
    ITerminaltxnCurrency["CONGOLESE_FRANC_CDF"] = "CDF";
    ITerminaltxnCurrency["WIR_EURO_CHE"] = "CHE";
    ITerminaltxnCurrency["SWISS_FRANC_CHF"] = "CHF";
    ITerminaltxnCurrency["WIR_FRANC_CHW"] = "CHW";
    ITerminaltxnCurrency["UNIDAD_DE_FOMENTO_CLF"] = "CLF";
    ITerminaltxnCurrency["CHILEAN_PESO_CLP"] = "CLP";
    ITerminaltxnCurrency["RENMINBI_CHINESE_YUAN_CNY"] = "CNY";
    ITerminaltxnCurrency["COLOMBIAN_PESO_COP"] = "COP";
    ITerminaltxnCurrency["UNIDAD_DE_VALOR_REAL_COU"] = "COU";
    ITerminaltxnCurrency["COSTA_RICAN_COLON_CRC"] = "CRC";
    ITerminaltxnCurrency["CUBAN_CONVERTIBLE_PESO_CUC"] = "CUC";
    ITerminaltxnCurrency["CUBAN_PESO_CUP"] = "CUP";
    ITerminaltxnCurrency["CAPE_VERDE_ESCUDO_CVE"] = "CVE";
    ITerminaltxnCurrency["CZECH_KORUNA_CZK"] = "CZK";
    ITerminaltxnCurrency["DJIBOUTIAN_FRANC_DJF"] = "DJF";
    ITerminaltxnCurrency["DANISH_KRONE_DKK"] = "DKK";
    ITerminaltxnCurrency["DOMINICAN_PESO_DOP"] = "DOP";
    ITerminaltxnCurrency["ALGERIAN_DINAR_DZD"] = "DZD";
    ITerminaltxnCurrency["EGYPTIAN_POUND_EGP"] = "EGP";
    ITerminaltxnCurrency["ERITREAN_NAKFA_ERN"] = "ERN";
    ITerminaltxnCurrency["ETHIOPIAN_BIRR_ETB"] = "ETB";
    ITerminaltxnCurrency["EURO_EUR"] = "EUR";
    ITerminaltxnCurrency["FIJI_DOLLAR_FJD"] = "FJD";
    ITerminaltxnCurrency["FALKLAND_ISLANDS_POUND_FKP"] = "FKP";
    ITerminaltxnCurrency["POUND_STERLING_GBP"] = "GBP";
    ITerminaltxnCurrency["GEORGIAN_LARI_GEL"] = "GEL";
    ITerminaltxnCurrency["GHANAIAN_CEDI_GHS"] = "GHS";
    ITerminaltxnCurrency["GIBRALTAR_POUND_GIP"] = "GIP";
    ITerminaltxnCurrency["GAMBIAN_DALASI_GMD"] = "GMD";
    ITerminaltxnCurrency["GUINEAN_FRANC_GNF"] = "GNF";
    ITerminaltxnCurrency["GUATEMALAN_QUETZAL_GTQ"] = "GTQ";
    ITerminaltxnCurrency["GUYANESE_DOLLAR_GYD"] = "GYD";
    ITerminaltxnCurrency["HONG_KONG_DOLLAR_HKD"] = "HKD";
    ITerminaltxnCurrency["HONDURAN_LEMPIRA_HNL"] = "HNL";
    ITerminaltxnCurrency["CROATIAN_KUNA_HRK"] = "HRK";
    ITerminaltxnCurrency["HAITIAN_GOURDE_HTG"] = "HTG";
    ITerminaltxnCurrency["HUNGARIAN_FORINT_HUF"] = "HUF";
    ITerminaltxnCurrency["INDONESIAN_RUPIAH_IDR"] = "IDR";
    ITerminaltxnCurrency["ISRAELI_NEW_SHEKEL_ILS"] = "ILS";
    ITerminaltxnCurrency["INDIAN_RUPEE_INR"] = "INR";
    ITerminaltxnCurrency["IRAQI_DINAR_IQD"] = "IQD";
    ITerminaltxnCurrency["IRANIAN_RIAL_IRR"] = "IRR";
    ITerminaltxnCurrency["ICELANDIC_KRNA_ISK"] = "ISK";
    ITerminaltxnCurrency["JAMAICAN_DOLLAR_JMD"] = "JMD";
    ITerminaltxnCurrency["JORDANIAN_DINAR_JOD"] = "JOD";
    ITerminaltxnCurrency["JAPANESE_YEN_JPY"] = "JPY";
    ITerminaltxnCurrency["KENYAN_SHILLING_KES"] = "KES";
    ITerminaltxnCurrency["KYRGYZSTANI_SOM_KGS"] = "KGS";
    ITerminaltxnCurrency["CAMBODIAN_RIEL_KHR"] = "KHR";
    ITerminaltxnCurrency["COMORO_FRANC_KMF"] = "KMF";
    ITerminaltxnCurrency["NORTH_KOREAN_WON_KPW"] = "KPW";
    ITerminaltxnCurrency["SOUTH_KOREAN_WON_KRW"] = "KRW";
    ITerminaltxnCurrency["KUWAITI_DINAR_KWD"] = "KWD";
    ITerminaltxnCurrency["CAYMAN_ISLANDS_DOLLAR_KYD"] = "KYD";
    ITerminaltxnCurrency["KAZAKHSTANI_TENGE_KZT"] = "KZT";
    ITerminaltxnCurrency["LAO_KIP_LAK"] = "LAK";
    ITerminaltxnCurrency["LEBANESE_POUND_LBP"] = "LBP";
    ITerminaltxnCurrency["SRI_LANKAN_RUPEE_LKR"] = "LKR";
    ITerminaltxnCurrency["LIBERIAN_DOLLAR_LRD"] = "LRD";
    ITerminaltxnCurrency["LESOTHO_LOTI_LSL"] = "LSL";
    ITerminaltxnCurrency["LIBYAN_DINAR_LYD"] = "LYD";
    ITerminaltxnCurrency["MOROCCAN_DIRHAM_MAD"] = "MAD";
    ITerminaltxnCurrency["MOLDOVAN_LEU_MDL"] = "MDL";
    ITerminaltxnCurrency["MALAGASY_ARIARY_MGA"] = "MGA";
    ITerminaltxnCurrency["MACEDONIAN_DENAR_MKD"] = "MKD";
    ITerminaltxnCurrency["MYANMAR_KYAT_MMK"] = "MMK";
    ITerminaltxnCurrency["MONGOLIAN_TGRG_MNT"] = "MNT";
    ITerminaltxnCurrency["MACANESE_PATACA_MOP"] = "MOP";
    ITerminaltxnCurrency["MAURITANIAN_OUGUIYA_MRU"] = "MRU";
    ITerminaltxnCurrency["MAURITIAN_RUPEE_MUR"] = "MUR";
    ITerminaltxnCurrency["MALDIVIAN_RUFIYAA_MVR"] = "MVR";
    ITerminaltxnCurrency["MALAWIAN_KWACHA_MWK"] = "MWK";
    ITerminaltxnCurrency["MEXICAN_PESO_MXN"] = "MXN";
    ITerminaltxnCurrency["MEXICAN_UNIDAD_DE_INVERSION_MXV"] = "MXV";
    ITerminaltxnCurrency["MALAYSIAN_RINGGIT_MYR"] = "MYR";
    ITerminaltxnCurrency["MOZAMBICAN_METICAL_MZN"] = "MZN";
    ITerminaltxnCurrency["NAMIBIAN_DOLLAR_NAD"] = "NAD";
    ITerminaltxnCurrency["NIGERIAN_NAIRA_NGN"] = "NGN";
    ITerminaltxnCurrency["NICARAGUAN_CRDOBA_NIO"] = "NIO";
    ITerminaltxnCurrency["NORWEGIAN_KRONE_NOK"] = "NOK";
    ITerminaltxnCurrency["NEPALESE_RUPEE_NPR"] = "NPR";
    ITerminaltxnCurrency["NEW_ZEALAND_DOLLAR_NZD"] = "NZD";
    ITerminaltxnCurrency["OMANI_RIAL_OMR"] = "OMR";
    ITerminaltxnCurrency["PANAMANIAN_BALBOA_PAB"] = "PAB";
    ITerminaltxnCurrency["PERUVIAN_SOL_PEN"] = "PEN";
    ITerminaltxnCurrency["PAPUA_NEW_GUINEAN_KINA_PGK"] = "PGK";
    ITerminaltxnCurrency["PHILIPPINE_PISO_PHP"] = "PHP";
    ITerminaltxnCurrency["PAKISTANI_RUPEE_PKR"] = "PKR";
    ITerminaltxnCurrency["POLISH_ZOTY_PLN"] = "PLN";
    ITerminaltxnCurrency["PARAGUAYAN_GUARAN_PYG"] = "PYG";
    ITerminaltxnCurrency["QATARI_RIYAL_QAR"] = "QAR";
    ITerminaltxnCurrency["ROMANIAN_LEU_RON"] = "RON";
    ITerminaltxnCurrency["SERBIAN_DINAR_RSD"] = "RSD";
    ITerminaltxnCurrency["RUSSIAN_RUBLE_RUB"] = "RUB";
    ITerminaltxnCurrency["RWANDAN_FRANC_RWF"] = "RWF";
    ITerminaltxnCurrency["SAUDI_RIYAL_SAR"] = "SAR";
    ITerminaltxnCurrency["SOLOMON_ISLANDS_DOLLAR_SBD"] = "SBD";
    ITerminaltxnCurrency["SEYCHELLES_RUPEE_SCR"] = "SCR";
    ITerminaltxnCurrency["SUDANESE_POUND_SDG"] = "SDG";
    ITerminaltxnCurrency["SWEDISH_KRONAKRONOR_SEK"] = "SEK";
    ITerminaltxnCurrency["SINGAPORE_DOLLAR_SGD"] = "SGD";
    ITerminaltxnCurrency["SAINT_HELENA_POUND_SHP"] = "SHP";
    ITerminaltxnCurrency["SIERRA_LEONEAN_LEONE_SLL"] = "SLL";
    ITerminaltxnCurrency["SOMALI_SHILLING_SOS"] = "SOS";
    ITerminaltxnCurrency["SURINAMESE_DOLLAR_SRD"] = "SRD";
    ITerminaltxnCurrency["SOUTH_SUDANESE_POUND_SSP"] = "SSP";
    ITerminaltxnCurrency["SO_TOM_AND_PRNCIPE_DOBRA_STN"] = "STN";
    ITerminaltxnCurrency["SALVADORAN_COLN_SVC"] = "SVC";
    ITerminaltxnCurrency["SYRIAN_POUND_SYP"] = "SYP";
    ITerminaltxnCurrency["SWAZI_LILANGENI_SZL"] = "SZL";
    ITerminaltxnCurrency["THAI_BAHT_THB"] = "THB";
    ITerminaltxnCurrency["TAJIKISTANI_SOMONI_TJS"] = "TJS";
    ITerminaltxnCurrency["TURKMENISTAN_MANAT_TMT"] = "TMT";
    ITerminaltxnCurrency["TUNISIAN_DINAR_TND"] = "TND";
    ITerminaltxnCurrency["TONGAN_PAANGA_TOP"] = "TOP";
    ITerminaltxnCurrency["TURKISH_LIRA_TRY"] = "TRY";
    ITerminaltxnCurrency["TRINIDAD_AND_TOBAGO_DOLLAR_TTD"] = "TTD";
    ITerminaltxnCurrency["NEW_TAIWAN_DOLLAR_TWD"] = "TWD";
    ITerminaltxnCurrency["TANZANIAN_SHILLING_TZS"] = "TZS";
    ITerminaltxnCurrency["UKRAINIAN_HRYVNIA_UAH"] = "UAH";
    ITerminaltxnCurrency["UGANDAN_SHILLING_UGX"] = "UGX";
    ITerminaltxnCurrency["UNITED_STATES_DOLLAR_USD"] = "USD";
    ITerminaltxnCurrency["UNITED_STATES_DOLLAR_USN"] = "USN";
    ITerminaltxnCurrency["URUGUAY_PESO_EN_UNIDADES_INDEXADAS_UYI"] = "UYI";
    ITerminaltxnCurrency["URUGUAYAN_PESO_UYU"] = "UYU";
    ITerminaltxnCurrency["UZBEKISTAN_SOM_UZS"] = "UZS";
    ITerminaltxnCurrency["VENEZUELAN_BOLVAR_VEF"] = "VEF";
    ITerminaltxnCurrency["VIETNAMESE_NG_VND"] = "VND";
    ITerminaltxnCurrency["VANUATU_VATU_VUV"] = "VUV";
    ITerminaltxnCurrency["SAMOAN_TALA_WST"] = "WST";
    ITerminaltxnCurrency["CFA_FRANC_BEAC_XAF"] = "XAF";
    ITerminaltxnCurrency["SILVER_XAG"] = "XAG";
    ITerminaltxnCurrency["GOLD_XAU"] = "XAU";
    ITerminaltxnCurrency["EUROPEAN_COMPOSITE_UNIT_XBA"] = "XBA";
    ITerminaltxnCurrency["EUROPEAN_MONETARY_UNIT_XBB"] = "XBB";
    ITerminaltxnCurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBC"] = "XBC";
    ITerminaltxnCurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBD"] = "XBD";
    ITerminaltxnCurrency["EAST_CARIBBEAN_DOLLAR_XCD"] = "XCD";
    ITerminaltxnCurrency["SPECIAL_DRAWING_RIGHTS_XDR"] = "XDR";
    ITerminaltxnCurrency["CFA_FRANC_BCEAO_XOF"] = "XOF";
    ITerminaltxnCurrency["PALLADIUM_XPD"] = "XPD";
    ITerminaltxnCurrency["CFP_FRANC_XPF"] = "XPF";
    ITerminaltxnCurrency["PLATINUM_XPT"] = "XPT";
    ITerminaltxnCurrency["SUCRE_XSU"] = "XSU";
    ITerminaltxnCurrency["ADB_UNIT_OF_ACCOUNT_XUA"] = "XUA";
    ITerminaltxnCurrency["YEMENI_RIAL_YER"] = "YER";
    ITerminaltxnCurrency["SOUTH_AFRICAN_RAND_ZAR"] = "ZAR";
    ITerminaltxnCurrency["ZAMBIAN_KWACHA_ZMW"] = "ZMW";
    ITerminaltxnCurrency["ZIMBABWEAN_DOLLAR_ZWL"] = "ZWL";
})(ITerminaltxnCurrency = exports.ITerminaltxnCurrency || (exports.ITerminaltxnCurrency = {}));
var ITerminaltxnFundingcurrency;
(function (ITerminaltxnFundingcurrency) {
    ITerminaltxnFundingcurrency["UNITED_ARAB_EMIRATES_DIRHAM_AED"] = "AED";
    ITerminaltxnFundingcurrency["AFGHAN_AFGHANI_AFN"] = "AFN";
    ITerminaltxnFundingcurrency["ALBANIAN_LEK_ALL"] = "ALL";
    ITerminaltxnFundingcurrency["ARMENIAN_DRAM_AMD"] = "AMD";
    ITerminaltxnFundingcurrency["NETHERLANDS_ANTILLEAN_GUILDER_ANG"] = "ANG";
    ITerminaltxnFundingcurrency["ANGOLAN_KWANZA_AOA"] = "AOA";
    ITerminaltxnFundingcurrency["ARGENTINE_PESO_ARS"] = "ARS";
    ITerminaltxnFundingcurrency["AUSTRALIAN_DOLLAR_AUD"] = "AUD";
    ITerminaltxnFundingcurrency["ARUBAN_FLORIN_AWG"] = "AWG";
    ITerminaltxnFundingcurrency["AZERBAIJANI_MANAT_AZN"] = "AZN";
    ITerminaltxnFundingcurrency["BOSNIA_AND_HERZEGOVINA_CONVERTIBLE_MARK_BAM"] = "BAM";
    ITerminaltxnFundingcurrency["BARBADOS_DOLLAR_BBD"] = "BBD";
    ITerminaltxnFundingcurrency["BANGLADESHI_TAKA_BDT"] = "BDT";
    ITerminaltxnFundingcurrency["BULGARIAN_LEV_BGN"] = "BGN";
    ITerminaltxnFundingcurrency["BAHRAINI_DINAR_BHD"] = "BHD";
    ITerminaltxnFundingcurrency["BURUNDIAN_FRANC_BIF"] = "BIF";
    ITerminaltxnFundingcurrency["BERMUDIAN_DOLLAR_BMD"] = "BMD";
    ITerminaltxnFundingcurrency["BRUNEI_DOLLAR_BND"] = "BND";
    ITerminaltxnFundingcurrency["BOLIVIANO_BOB"] = "BOB";
    ITerminaltxnFundingcurrency["BOLIVIAN_MVDOL_BOV"] = "BOV";
    ITerminaltxnFundingcurrency["BRAZILIAN_REAL_BRL"] = "BRL";
    ITerminaltxnFundingcurrency["BAHAMIAN_DOLLAR_BSD"] = "BSD";
    ITerminaltxnFundingcurrency["BHUTANESE_NGULTRUM_BTN"] = "BTN";
    ITerminaltxnFundingcurrency["BOTSWANA_PULA_BWP"] = "BWP";
    ITerminaltxnFundingcurrency["BELARUSIAN_RUBLE_BYN"] = "BYN";
    ITerminaltxnFundingcurrency["BELIZE_DOLLAR_BZD"] = "BZD";
    ITerminaltxnFundingcurrency["CANADIAN_DOLLAR_CAD"] = "CAD";
    ITerminaltxnFundingcurrency["CONGOLESE_FRANC_CDF"] = "CDF";
    ITerminaltxnFundingcurrency["WIR_EURO_CHE"] = "CHE";
    ITerminaltxnFundingcurrency["SWISS_FRANC_CHF"] = "CHF";
    ITerminaltxnFundingcurrency["WIR_FRANC_CHW"] = "CHW";
    ITerminaltxnFundingcurrency["UNIDAD_DE_FOMENTO_CLF"] = "CLF";
    ITerminaltxnFundingcurrency["CHILEAN_PESO_CLP"] = "CLP";
    ITerminaltxnFundingcurrency["RENMINBI_CHINESE_YUAN_CNY"] = "CNY";
    ITerminaltxnFundingcurrency["COLOMBIAN_PESO_COP"] = "COP";
    ITerminaltxnFundingcurrency["UNIDAD_DE_VALOR_REAL_COU"] = "COU";
    ITerminaltxnFundingcurrency["COSTA_RICAN_COLON_CRC"] = "CRC";
    ITerminaltxnFundingcurrency["CUBAN_CONVERTIBLE_PESO_CUC"] = "CUC";
    ITerminaltxnFundingcurrency["CUBAN_PESO_CUP"] = "CUP";
    ITerminaltxnFundingcurrency["CAPE_VERDE_ESCUDO_CVE"] = "CVE";
    ITerminaltxnFundingcurrency["CZECH_KORUNA_CZK"] = "CZK";
    ITerminaltxnFundingcurrency["DJIBOUTIAN_FRANC_DJF"] = "DJF";
    ITerminaltxnFundingcurrency["DANISH_KRONE_DKK"] = "DKK";
    ITerminaltxnFundingcurrency["DOMINICAN_PESO_DOP"] = "DOP";
    ITerminaltxnFundingcurrency["ALGERIAN_DINAR_DZD"] = "DZD";
    ITerminaltxnFundingcurrency["EGYPTIAN_POUND_EGP"] = "EGP";
    ITerminaltxnFundingcurrency["ERITREAN_NAKFA_ERN"] = "ERN";
    ITerminaltxnFundingcurrency["ETHIOPIAN_BIRR_ETB"] = "ETB";
    ITerminaltxnFundingcurrency["EURO_EUR"] = "EUR";
    ITerminaltxnFundingcurrency["FIJI_DOLLAR_FJD"] = "FJD";
    ITerminaltxnFundingcurrency["FALKLAND_ISLANDS_POUND_FKP"] = "FKP";
    ITerminaltxnFundingcurrency["POUND_STERLING_GBP"] = "GBP";
    ITerminaltxnFundingcurrency["GEORGIAN_LARI_GEL"] = "GEL";
    ITerminaltxnFundingcurrency["GHANAIAN_CEDI_GHS"] = "GHS";
    ITerminaltxnFundingcurrency["GIBRALTAR_POUND_GIP"] = "GIP";
    ITerminaltxnFundingcurrency["GAMBIAN_DALASI_GMD"] = "GMD";
    ITerminaltxnFundingcurrency["GUINEAN_FRANC_GNF"] = "GNF";
    ITerminaltxnFundingcurrency["GUATEMALAN_QUETZAL_GTQ"] = "GTQ";
    ITerminaltxnFundingcurrency["GUYANESE_DOLLAR_GYD"] = "GYD";
    ITerminaltxnFundingcurrency["HONG_KONG_DOLLAR_HKD"] = "HKD";
    ITerminaltxnFundingcurrency["HONDURAN_LEMPIRA_HNL"] = "HNL";
    ITerminaltxnFundingcurrency["CROATIAN_KUNA_HRK"] = "HRK";
    ITerminaltxnFundingcurrency["HAITIAN_GOURDE_HTG"] = "HTG";
    ITerminaltxnFundingcurrency["HUNGARIAN_FORINT_HUF"] = "HUF";
    ITerminaltxnFundingcurrency["INDONESIAN_RUPIAH_IDR"] = "IDR";
    ITerminaltxnFundingcurrency["ISRAELI_NEW_SHEKEL_ILS"] = "ILS";
    ITerminaltxnFundingcurrency["INDIAN_RUPEE_INR"] = "INR";
    ITerminaltxnFundingcurrency["IRAQI_DINAR_IQD"] = "IQD";
    ITerminaltxnFundingcurrency["IRANIAN_RIAL_IRR"] = "IRR";
    ITerminaltxnFundingcurrency["ICELANDIC_KRNA_ISK"] = "ISK";
    ITerminaltxnFundingcurrency["JAMAICAN_DOLLAR_JMD"] = "JMD";
    ITerminaltxnFundingcurrency["JORDANIAN_DINAR_JOD"] = "JOD";
    ITerminaltxnFundingcurrency["JAPANESE_YEN_JPY"] = "JPY";
    ITerminaltxnFundingcurrency["KENYAN_SHILLING_KES"] = "KES";
    ITerminaltxnFundingcurrency["KYRGYZSTANI_SOM_KGS"] = "KGS";
    ITerminaltxnFundingcurrency["CAMBODIAN_RIEL_KHR"] = "KHR";
    ITerminaltxnFundingcurrency["COMORO_FRANC_KMF"] = "KMF";
    ITerminaltxnFundingcurrency["NORTH_KOREAN_WON_KPW"] = "KPW";
    ITerminaltxnFundingcurrency["SOUTH_KOREAN_WON_KRW"] = "KRW";
    ITerminaltxnFundingcurrency["KUWAITI_DINAR_KWD"] = "KWD";
    ITerminaltxnFundingcurrency["CAYMAN_ISLANDS_DOLLAR_KYD"] = "KYD";
    ITerminaltxnFundingcurrency["KAZAKHSTANI_TENGE_KZT"] = "KZT";
    ITerminaltxnFundingcurrency["LAO_KIP_LAK"] = "LAK";
    ITerminaltxnFundingcurrency["LEBANESE_POUND_LBP"] = "LBP";
    ITerminaltxnFundingcurrency["SRI_LANKAN_RUPEE_LKR"] = "LKR";
    ITerminaltxnFundingcurrency["LIBERIAN_DOLLAR_LRD"] = "LRD";
    ITerminaltxnFundingcurrency["LESOTHO_LOTI_LSL"] = "LSL";
    ITerminaltxnFundingcurrency["LIBYAN_DINAR_LYD"] = "LYD";
    ITerminaltxnFundingcurrency["MOROCCAN_DIRHAM_MAD"] = "MAD";
    ITerminaltxnFundingcurrency["MOLDOVAN_LEU_MDL"] = "MDL";
    ITerminaltxnFundingcurrency["MALAGASY_ARIARY_MGA"] = "MGA";
    ITerminaltxnFundingcurrency["MACEDONIAN_DENAR_MKD"] = "MKD";
    ITerminaltxnFundingcurrency["MYANMAR_KYAT_MMK"] = "MMK";
    ITerminaltxnFundingcurrency["MONGOLIAN_TGRG_MNT"] = "MNT";
    ITerminaltxnFundingcurrency["MACANESE_PATACA_MOP"] = "MOP";
    ITerminaltxnFundingcurrency["MAURITANIAN_OUGUIYA_MRU"] = "MRU";
    ITerminaltxnFundingcurrency["MAURITIAN_RUPEE_MUR"] = "MUR";
    ITerminaltxnFundingcurrency["MALDIVIAN_RUFIYAA_MVR"] = "MVR";
    ITerminaltxnFundingcurrency["MALAWIAN_KWACHA_MWK"] = "MWK";
    ITerminaltxnFundingcurrency["MEXICAN_PESO_MXN"] = "MXN";
    ITerminaltxnFundingcurrency["MEXICAN_UNIDAD_DE_INVERSION_MXV"] = "MXV";
    ITerminaltxnFundingcurrency["MALAYSIAN_RINGGIT_MYR"] = "MYR";
    ITerminaltxnFundingcurrency["MOZAMBICAN_METICAL_MZN"] = "MZN";
    ITerminaltxnFundingcurrency["NAMIBIAN_DOLLAR_NAD"] = "NAD";
    ITerminaltxnFundingcurrency["NIGERIAN_NAIRA_NGN"] = "NGN";
    ITerminaltxnFundingcurrency["NICARAGUAN_CRDOBA_NIO"] = "NIO";
    ITerminaltxnFundingcurrency["NORWEGIAN_KRONE_NOK"] = "NOK";
    ITerminaltxnFundingcurrency["NEPALESE_RUPEE_NPR"] = "NPR";
    ITerminaltxnFundingcurrency["NEW_ZEALAND_DOLLAR_NZD"] = "NZD";
    ITerminaltxnFundingcurrency["OMANI_RIAL_OMR"] = "OMR";
    ITerminaltxnFundingcurrency["PANAMANIAN_BALBOA_PAB"] = "PAB";
    ITerminaltxnFundingcurrency["PERUVIAN_SOL_PEN"] = "PEN";
    ITerminaltxnFundingcurrency["PAPUA_NEW_GUINEAN_KINA_PGK"] = "PGK";
    ITerminaltxnFundingcurrency["PHILIPPINE_PISO_PHP"] = "PHP";
    ITerminaltxnFundingcurrency["PAKISTANI_RUPEE_PKR"] = "PKR";
    ITerminaltxnFundingcurrency["POLISH_ZOTY_PLN"] = "PLN";
    ITerminaltxnFundingcurrency["PARAGUAYAN_GUARAN_PYG"] = "PYG";
    ITerminaltxnFundingcurrency["QATARI_RIYAL_QAR"] = "QAR";
    ITerminaltxnFundingcurrency["ROMANIAN_LEU_RON"] = "RON";
    ITerminaltxnFundingcurrency["SERBIAN_DINAR_RSD"] = "RSD";
    ITerminaltxnFundingcurrency["RUSSIAN_RUBLE_RUB"] = "RUB";
    ITerminaltxnFundingcurrency["RWANDAN_FRANC_RWF"] = "RWF";
    ITerminaltxnFundingcurrency["SAUDI_RIYAL_SAR"] = "SAR";
    ITerminaltxnFundingcurrency["SOLOMON_ISLANDS_DOLLAR_SBD"] = "SBD";
    ITerminaltxnFundingcurrency["SEYCHELLES_RUPEE_SCR"] = "SCR";
    ITerminaltxnFundingcurrency["SUDANESE_POUND_SDG"] = "SDG";
    ITerminaltxnFundingcurrency["SWEDISH_KRONAKRONOR_SEK"] = "SEK";
    ITerminaltxnFundingcurrency["SINGAPORE_DOLLAR_SGD"] = "SGD";
    ITerminaltxnFundingcurrency["SAINT_HELENA_POUND_SHP"] = "SHP";
    ITerminaltxnFundingcurrency["SIERRA_LEONEAN_LEONE_SLL"] = "SLL";
    ITerminaltxnFundingcurrency["SOMALI_SHILLING_SOS"] = "SOS";
    ITerminaltxnFundingcurrency["SURINAMESE_DOLLAR_SRD"] = "SRD";
    ITerminaltxnFundingcurrency["SOUTH_SUDANESE_POUND_SSP"] = "SSP";
    ITerminaltxnFundingcurrency["SO_TOM_AND_PRNCIPE_DOBRA_STN"] = "STN";
    ITerminaltxnFundingcurrency["SALVADORAN_COLN_SVC"] = "SVC";
    ITerminaltxnFundingcurrency["SYRIAN_POUND_SYP"] = "SYP";
    ITerminaltxnFundingcurrency["SWAZI_LILANGENI_SZL"] = "SZL";
    ITerminaltxnFundingcurrency["THAI_BAHT_THB"] = "THB";
    ITerminaltxnFundingcurrency["TAJIKISTANI_SOMONI_TJS"] = "TJS";
    ITerminaltxnFundingcurrency["TURKMENISTAN_MANAT_TMT"] = "TMT";
    ITerminaltxnFundingcurrency["TUNISIAN_DINAR_TND"] = "TND";
    ITerminaltxnFundingcurrency["TONGAN_PAANGA_TOP"] = "TOP";
    ITerminaltxnFundingcurrency["TURKISH_LIRA_TRY"] = "TRY";
    ITerminaltxnFundingcurrency["TRINIDAD_AND_TOBAGO_DOLLAR_TTD"] = "TTD";
    ITerminaltxnFundingcurrency["NEW_TAIWAN_DOLLAR_TWD"] = "TWD";
    ITerminaltxnFundingcurrency["TANZANIAN_SHILLING_TZS"] = "TZS";
    ITerminaltxnFundingcurrency["UKRAINIAN_HRYVNIA_UAH"] = "UAH";
    ITerminaltxnFundingcurrency["UGANDAN_SHILLING_UGX"] = "UGX";
    ITerminaltxnFundingcurrency["UNITED_STATES_DOLLAR_USD"] = "USD";
    ITerminaltxnFundingcurrency["UNITED_STATES_DOLLAR_USN"] = "USN";
    ITerminaltxnFundingcurrency["URUGUAY_PESO_EN_UNIDADES_INDEXADAS_UYI"] = "UYI";
    ITerminaltxnFundingcurrency["URUGUAYAN_PESO_UYU"] = "UYU";
    ITerminaltxnFundingcurrency["UZBEKISTAN_SOM_UZS"] = "UZS";
    ITerminaltxnFundingcurrency["VENEZUELAN_BOLVAR_VEF"] = "VEF";
    ITerminaltxnFundingcurrency["VIETNAMESE_NG_VND"] = "VND";
    ITerminaltxnFundingcurrency["VANUATU_VATU_VUV"] = "VUV";
    ITerminaltxnFundingcurrency["SAMOAN_TALA_WST"] = "WST";
    ITerminaltxnFundingcurrency["CFA_FRANC_BEAC_XAF"] = "XAF";
    ITerminaltxnFundingcurrency["SILVER_XAG"] = "XAG";
    ITerminaltxnFundingcurrency["GOLD_XAU"] = "XAU";
    ITerminaltxnFundingcurrency["EUROPEAN_COMPOSITE_UNIT_XBA"] = "XBA";
    ITerminaltxnFundingcurrency["EUROPEAN_MONETARY_UNIT_XBB"] = "XBB";
    ITerminaltxnFundingcurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBC"] = "XBC";
    ITerminaltxnFundingcurrency["EUROPEAN_UNIT_OF_ACCOUNT_XBD"] = "XBD";
    ITerminaltxnFundingcurrency["EAST_CARIBBEAN_DOLLAR_XCD"] = "XCD";
    ITerminaltxnFundingcurrency["SPECIAL_DRAWING_RIGHTS_XDR"] = "XDR";
    ITerminaltxnFundingcurrency["CFA_FRANC_BCEAO_XOF"] = "XOF";
    ITerminaltxnFundingcurrency["PALLADIUM_XPD"] = "XPD";
    ITerminaltxnFundingcurrency["CFP_FRANC_XPF"] = "XPF";
    ITerminaltxnFundingcurrency["PLATINUM_XPT"] = "XPT";
    ITerminaltxnFundingcurrency["SUCRE_XSU"] = "XSU";
    ITerminaltxnFundingcurrency["ADB_UNIT_OF_ACCOUNT_XUA"] = "XUA";
    ITerminaltxnFundingcurrency["YEMENI_RIAL_YER"] = "YER";
    ITerminaltxnFundingcurrency["SOUTH_AFRICAN_RAND_ZAR"] = "ZAR";
    ITerminaltxnFundingcurrency["ZAMBIAN_KWACHA_ZMW"] = "ZMW";
    ITerminaltxnFundingcurrency["ZIMBABWEAN_DOLLAR_ZWL"] = "ZWL";
})(ITerminaltxnFundingcurrency = exports.ITerminaltxnFundingcurrency || (exports.ITerminaltxnFundingcurrency = {}));
var ITerminaltxnTerminalcapability;
(function (ITerminaltxnTerminalcapability) {
    ITerminaltxnTerminalcapability[ITerminaltxnTerminalcapability["KEY_ENTRY_ONLY_TERMINAL_1"] = 1] = "KEY_ENTRY_ONLY_TERMINAL_1";
    ITerminaltxnTerminalcapability[ITerminaltxnTerminalcapability["CAN_READ_MAGNETIC_STRIPE_2"] = 2] = "CAN_READ_MAGNETIC_STRIPE_2";
    ITerminaltxnTerminalcapability[ITerminaltxnTerminalcapability["INTEGRATED_CIRCUIT_READER_3"] = 3] = "INTEGRATED_CIRCUIT_READER_3";
    ITerminaltxnTerminalcapability[ITerminaltxnTerminalcapability["DEFAULT_4"] = 4] = "DEFAULT_4";
})(ITerminaltxnTerminalcapability = exports.ITerminaltxnTerminalcapability || (exports.ITerminaltxnTerminalcapability = {}));
var ITerminaltxnEntrymode;
(function (ITerminaltxnEntrymode) {
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["TERMINAL_USED_WITH_KEY_ENTRY_1"] = 1] = "TERMINAL_USED_WITH_KEY_ENTRY_1";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["TRACK__READ_2"] = 2] = "TRACK__READ_2";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["TRACK__READ_3"] = 3] = "TRACK__READ_3";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["COMPLETE_MAGNETIC_STRIPE_READ_4"] = 4] = "COMPLETE_MAGNETIC_STRIPE_READ_4";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["EMV_CHIP_READ_5"] = 5] = "EMV_CHIP_READ_5";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["DEFAULT_6"] = 6] = "DEFAULT_6";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["DEFAULT_7"] = 7] = "DEFAULT_7";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["DEFAULT_8"] = 8] = "DEFAULT_8";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["DEFAULT_9"] = 9] = "DEFAULT_9";
    ITerminaltxnEntrymode[ITerminaltxnEntrymode["DEFAULT_10"] = 10] = "DEFAULT_10";
})(ITerminaltxnEntrymode = exports.ITerminaltxnEntrymode || (exports.ITerminaltxnEntrymode = {}));
var ITerminaltxnOrigin;
(function (ITerminaltxnOrigin) {
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_AT_A_CREDIT_CARD_TERMINAL_1"] = 1] = "ORIGINATED_AT_A_CREDIT_CARD_TERMINAL_1";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_THROUGH_AN_ECOMMERCE_SYSTEM_2"] = 2] = "ORIGINATED_THROUGH_AN_ECOMMERCE_SYSTEM_2";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_AS_A_MAIL_ORDER_OR_TELEPHONE_ORDER_TRANSACTION_3"] = 3] = "ORIGINATED_AS_A_MAIL_ORDER_OR_TELEPHONE_ORDER_TRANSACTION_3";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_WITH_APPLE_PAY_4"] = 4] = "ORIGINATED_WITH_APPLE_PAY_4";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_AS_A_SUCCESSFUL_D_SECURE_TRANSACTION_5"] = 5] = "ORIGINATED_AS_A_SUCCESSFUL_D_SECURE_TRANSACTION_5";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_AS_AN_ATTEMPTED_D_SECURE_TRANSACTION_6"] = 6] = "ORIGINATED_AS_AN_ATTEMPTED_D_SECURE_TRANSACTION_6";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_AS_A_RECURRING_TRANSACTION_ON_THE_CARD_7"] = 7] = "ORIGINATED_AS_A_RECURRING_TRANSACTION_ON_THE_CARD_7";
    ITerminaltxnOrigin[ITerminaltxnOrigin["ORIGINATED_IN_A_PAYFRAME_8"] = 8] = "ORIGINATED_IN_A_PAYFRAME_8";
})(ITerminaltxnOrigin = exports.ITerminaltxnOrigin || (exports.ITerminaltxnOrigin = {}));
var ITerminaltxnCvvstatus;
(function (ITerminaltxnCvvstatus) {
    ITerminaltxnCvvstatus["CVV_IS_NOT_PRESENT_NOTPRESENT"] = "notPresent";
    ITerminaltxnCvvstatus["CVV_IS_ILLEGIBLE_ILLEGIBLE"] = "illegible";
    ITerminaltxnCvvstatus["CVV_WAS_NOT_PROVIDED_NOTPROVIDED"] = "notProvided";
})(ITerminaltxnCvvstatus = exports.ITerminaltxnCvvstatus || (exports.ITerminaltxnCvvstatus = {}));
var ITerminaltxnSwiped;
(function (ITerminaltxnSwiped) {
    ITerminaltxnSwiped[ITerminaltxnSwiped["NOT_SWIPED_0"] = 0] = "NOT_SWIPED_0";
    ITerminaltxnSwiped[ITerminaltxnSwiped["SWIPED_1"] = 1] = "SWIPED_1";
})(ITerminaltxnSwiped = exports.ITerminaltxnSwiped || (exports.ITerminaltxnSwiped = {}));
var ITerminaltxnEmv;
(function (ITerminaltxnEmv) {
    ITerminaltxnEmv[ITerminaltxnEmv["NOT_DIPPED_0"] = 0] = "NOT_DIPPED_0";
    ITerminaltxnEmv[ITerminaltxnEmv["DIPPED_1"] = 1] = "DIPPED_1";
})(ITerminaltxnEmv = exports.ITerminaltxnEmv || (exports.ITerminaltxnEmv = {}));
var ITerminaltxnSignature;
(function (ITerminaltxnSignature) {
    ITerminaltxnSignature[ITerminaltxnSignature["NOT_CAPTURED_0"] = 0] = "NOT_CAPTURED_0";
    ITerminaltxnSignature[ITerminaltxnSignature["CAPTURED_1"] = 1] = "CAPTURED_1";
})(ITerminaltxnSignature = exports.ITerminaltxnSignature || (exports.ITerminaltxnSignature = {}));
var ITerminaltxnPin;
(function (ITerminaltxnPin) {
    ITerminaltxnPin[ITerminaltxnPin["PIN_NOT_ENTERED_0"] = 0] = "PIN_NOT_ENTERED_0";
    ITerminaltxnPin[ITerminaltxnPin["PIN_ENTERED_1"] = 1] = "PIN_ENTERED_1";
})(ITerminaltxnPin = exports.ITerminaltxnPin || (exports.ITerminaltxnPin = {}));
var ITerminaltxnUnattended;
(function (ITerminaltxnUnattended) {
    ITerminaltxnUnattended[ITerminaltxnUnattended["ATTENDED_TERMINAL_0"] = 0] = "ATTENDED_TERMINAL_0";
    ITerminaltxnUnattended[ITerminaltxnUnattended["UNATTENDED_TERMINAL_1"] = 1] = "UNATTENDED_TERMINAL_1";
})(ITerminaltxnUnattended = exports.ITerminaltxnUnattended || (exports.ITerminaltxnUnattended = {}));
var ITerminaltxnPos;
(function (ITerminaltxnPos) {
    ITerminaltxnPos[ITerminaltxnPos["POS_WILL_ACTIVATE_THE_TERMINAL_0"] = 0] = "POS_WILL_ACTIVATE_THE_TERMINAL_0";
    ITerminaltxnPos[ITerminaltxnPos["TERMINAL_NEEDS_EXTERNAL_ACTIVATION_1"] = 1] = "TERMINAL_NEEDS_EXTERNAL_ACTIVATION_1";
})(ITerminaltxnPos = exports.ITerminaltxnPos || (exports.ITerminaltxnPos = {}));
var ITerminaltxnReceipt;
(function (ITerminaltxnReceipt) {
    ITerminaltxnReceipt["NO_RECEIPT_NORECEIPT"] = "noReceipt";
    ITerminaltxnReceipt["MERCHANT_ONLY_MERCHANT"] = "merchant";
    ITerminaltxnReceipt["CUSTOMER_ONLY_CUSTOMER"] = "customer";
    ITerminaltxnReceipt["MERCHANTS_AND_CUSTOMERS_COPY_BOTH"] = "both";
})(ITerminaltxnReceipt = exports.ITerminaltxnReceipt || (exports.ITerminaltxnReceipt = {}));
var ITerminaltxnCountry;
(function (ITerminaltxnCountry) {
    ITerminaltxnCountry["ARUBA_ABW"] = "ABW";
    ITerminaltxnCountry["AFGHANISTAN_AFG"] = "AFG";
    ITerminaltxnCountry["ANGOLA_AGO"] = "AGO";
    ITerminaltxnCountry["ANGUILLA_AIA"] = "AIA";
    ITerminaltxnCountry["ALAND_ISLANDS_ALA"] = "ALA";
    ITerminaltxnCountry["ALBANIA_ALB"] = "ALB";
    ITerminaltxnCountry["ANDORRA_AND"] = "AND";
    ITerminaltxnCountry["UNITED_ARAB_EMIRATES_ARE"] = "ARE";
    ITerminaltxnCountry["ARGENTINA_ARG"] = "ARG";
    ITerminaltxnCountry["ARMENIA_ARM"] = "ARM";
    ITerminaltxnCountry["AMERICAN_SAMOA_ASM"] = "ASM";
    ITerminaltxnCountry["ANTARCTICA_ATA"] = "ATA";
    ITerminaltxnCountry["FRENCH_SOUTHERN_TERRITORIES_ATF"] = "ATF";
    ITerminaltxnCountry["ANTIGUA_AND_BARBUDA_ATG"] = "ATG";
    ITerminaltxnCountry["AUSTRALIA_AUS"] = "AUS";
    ITerminaltxnCountry["AUSTRIA_AUT"] = "AUT";
    ITerminaltxnCountry["AZERBAIJAN_AZE"] = "AZE";
    ITerminaltxnCountry["BURUNDI_BDI"] = "BDI";
    ITerminaltxnCountry["BELGIUM_BEL"] = "BEL";
    ITerminaltxnCountry["BENIN_BEN"] = "BEN";
    ITerminaltxnCountry["BONAIRE_SINT_EUSTATIUS_AND_SABA_BES"] = "BES";
    ITerminaltxnCountry["BURKINA_FASO_BFA"] = "BFA";
    ITerminaltxnCountry["BANGLADESH_BGD"] = "BGD";
    ITerminaltxnCountry["BULGARIA_BGR"] = "BGR";
    ITerminaltxnCountry["BAHRAIN_BHR"] = "BHR";
    ITerminaltxnCountry["BAHAMAS_BHS"] = "BHS";
    ITerminaltxnCountry["BOSNIA_AND_HERZEGOVINA_BIH"] = "BIH";
    ITerminaltxnCountry["SAINT_BARTHLEMY_BLM"] = "BLM";
    ITerminaltxnCountry["BELARUS_BLR"] = "BLR";
    ITerminaltxnCountry["BELIZE_BLZ"] = "BLZ";
    ITerminaltxnCountry["BERMUDA_BMU"] = "BMU";
    ITerminaltxnCountry["BOLIVIA_PLURINATIONAL_STATE_OF_BOL"] = "BOL";
    ITerminaltxnCountry["BRAZIL_BRA"] = "BRA";
    ITerminaltxnCountry["BARBADOS_BRB"] = "BRB";
    ITerminaltxnCountry["BRUNEI_DARUSSALAM_BRN"] = "BRN";
    ITerminaltxnCountry["BHUTAN_BTN"] = "BTN";
    ITerminaltxnCountry["BOUVET_ISLAND_BVT"] = "BVT";
    ITerminaltxnCountry["BOTSWANA_BWA"] = "BWA";
    ITerminaltxnCountry["CENTRAL_AFRICAN_REPUBLIC_CAF"] = "CAF";
    ITerminaltxnCountry["CANADA_CAN"] = "CAN";
    ITerminaltxnCountry["COCOS_KEELING_ISLANDS_CCK"] = "CCK";
    ITerminaltxnCountry["SWITZERLAND_CHE"] = "CHE";
    ITerminaltxnCountry["CHILE_CHL"] = "CHL";
    ITerminaltxnCountry["CHINA_CHN"] = "CHN";
    ITerminaltxnCountry["CTE_DIVOIRE_CIV"] = "CIV";
    ITerminaltxnCountry["CAMEROON_CMR"] = "CMR";
    ITerminaltxnCountry["CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE_COD"] = "COD";
    ITerminaltxnCountry["CONGO_COG"] = "COG";
    ITerminaltxnCountry["COOK_ISLANDS_COK"] = "COK";
    ITerminaltxnCountry["COLOMBIA_COL"] = "COL";
    ITerminaltxnCountry["COMOROS_COM"] = "COM";
    ITerminaltxnCountry["CAPE_VERDE_CPV"] = "CPV";
    ITerminaltxnCountry["COSTA_RICA_CRI"] = "CRI";
    ITerminaltxnCountry["CUBA_CUB"] = "CUB";
    ITerminaltxnCountry["CURAAO_CUW"] = "CUW";
    ITerminaltxnCountry["CHRISTMAS_ISLAND_CXR"] = "CXR";
    ITerminaltxnCountry["CAYMAN_ISLANDS_CYM"] = "CYM";
    ITerminaltxnCountry["CYPRUS_CYP"] = "CYP";
    ITerminaltxnCountry["CZECH_REPUBLIC_CZE"] = "CZE";
    ITerminaltxnCountry["GERMANY_DEU"] = "DEU";
    ITerminaltxnCountry["DJIBOUTI_DJI"] = "DJI";
    ITerminaltxnCountry["DOMINICA_DMA"] = "DMA";
    ITerminaltxnCountry["DENMARK_DNK"] = "DNK";
    ITerminaltxnCountry["DOMINICAN_REPUBLIC_DOM"] = "DOM";
    ITerminaltxnCountry["ALGERIA_DZA"] = "DZA";
    ITerminaltxnCountry["ECUADOR_ECU"] = "ECU";
    ITerminaltxnCountry["EGYPT_EGY"] = "EGY";
    ITerminaltxnCountry["ERITREA_ERI"] = "ERI";
    ITerminaltxnCountry["WESTERN_SAHARA_ESH"] = "ESH";
    ITerminaltxnCountry["SPAIN_ESP"] = "ESP";
    ITerminaltxnCountry["ESTONIA_EST"] = "EST";
    ITerminaltxnCountry["ETHIOPIA_ETH"] = "ETH";
    ITerminaltxnCountry["FINLAND_FIN"] = "FIN";
    ITerminaltxnCountry["FIJI_FJI"] = "FJI";
    ITerminaltxnCountry["FALKLAND_ISLANDS_MALVINAS_FLK"] = "FLK";
    ITerminaltxnCountry["FRANCE_FRA"] = "FRA";
    ITerminaltxnCountry["FAROE_ISLANDS_FRO"] = "FRO";
    ITerminaltxnCountry["MICRONESIA_FEDERATED_STATES_OF_FSM"] = "FSM";
    ITerminaltxnCountry["GABON_GAB"] = "GAB";
    ITerminaltxnCountry["UNITED_KINGDOM_GBR"] = "GBR";
    ITerminaltxnCountry["GEORGIA_GEO"] = "GEO";
    ITerminaltxnCountry["GUERNSEY_GGY"] = "GGY";
    ITerminaltxnCountry["GHANA_GHA"] = "GHA";
    ITerminaltxnCountry["GIBRALTAR_GIB"] = "GIB";
    ITerminaltxnCountry["GUINEA_GIN"] = "GIN";
    ITerminaltxnCountry["GUADELOUPE_GLP"] = "GLP";
    ITerminaltxnCountry["GAMBIA_GMB"] = "GMB";
    ITerminaltxnCountry["GUINEABISSAU_GNB"] = "GNB";
    ITerminaltxnCountry["EQUATORIAL_GUINEA_GNQ"] = "GNQ";
    ITerminaltxnCountry["GREECE_GRC"] = "GRC";
    ITerminaltxnCountry["GRENADA_GRD"] = "GRD";
    ITerminaltxnCountry["GREENLAND_GRL"] = "GRL";
    ITerminaltxnCountry["GUATEMALA_GTM"] = "GTM";
    ITerminaltxnCountry["FRENCH_GUIANA_GUF"] = "GUF";
    ITerminaltxnCountry["GUAM_GUM"] = "GUM";
    ITerminaltxnCountry["GUYANA_GUY"] = "GUY";
    ITerminaltxnCountry["HONG_KONG_HKG"] = "HKG";
    ITerminaltxnCountry["HEARD_ISLAND_AND_MCDONALD_ISLANDS_HMD"] = "HMD";
    ITerminaltxnCountry["HONDURAS_HND"] = "HND";
    ITerminaltxnCountry["CROATIA_HRV"] = "HRV";
    ITerminaltxnCountry["HAITI_HTI"] = "HTI";
    ITerminaltxnCountry["HUNGARY_HUN"] = "HUN";
    ITerminaltxnCountry["INDONESIA_IDN"] = "IDN";
    ITerminaltxnCountry["ISLE_OF_MAN_IMN"] = "IMN";
    ITerminaltxnCountry["INDIA_IND"] = "IND";
    ITerminaltxnCountry["BRITISH_INDIAN_OCEAN_TERRITORY_IOT"] = "IOT";
    ITerminaltxnCountry["IRELAND_IRL"] = "IRL";
    ITerminaltxnCountry["IRAN_ISLAMIC_REPUBLIC_OF_IRN"] = "IRN";
    ITerminaltxnCountry["IRAQ_IRQ"] = "IRQ";
    ITerminaltxnCountry["ICELAND_ISL"] = "ISL";
    ITerminaltxnCountry["ISRAEL_ISR"] = "ISR";
    ITerminaltxnCountry["ITALY_ITA"] = "ITA";
    ITerminaltxnCountry["JAMAICA_JAM"] = "JAM";
    ITerminaltxnCountry["JERSEY_JEY"] = "JEY";
    ITerminaltxnCountry["JORDAN_JOR"] = "JOR";
    ITerminaltxnCountry["JAPAN_JPN"] = "JPN";
    ITerminaltxnCountry["KAZAKHSTAN_KAZ"] = "KAZ";
    ITerminaltxnCountry["KENYA_KEN"] = "KEN";
    ITerminaltxnCountry["KYRGYZSTAN_KGZ"] = "KGZ";
    ITerminaltxnCountry["CAMBODIA_KHM"] = "KHM";
    ITerminaltxnCountry["KIRIBATI_KIR"] = "KIR";
    ITerminaltxnCountry["SAINT_KITTS_AND_NEVIS_KNA"] = "KNA";
    ITerminaltxnCountry["KOREA_REPUBLIC_OF_KOR"] = "KOR";
    ITerminaltxnCountry["KUWAIT_KWT"] = "KWT";
    ITerminaltxnCountry["LAO_PEOPLES_DEMOCRATIC_REPUBLIC_LAO"] = "LAO";
    ITerminaltxnCountry["LEBANON_LBN"] = "LBN";
    ITerminaltxnCountry["LIBERIA_LBR"] = "LBR";
    ITerminaltxnCountry["LIBYA_LBY"] = "LBY";
    ITerminaltxnCountry["SAINT_LUCIA_LCA"] = "LCA";
    ITerminaltxnCountry["LIECHTENSTEIN_LIE"] = "LIE";
    ITerminaltxnCountry["SRI_LANKA_LKA"] = "LKA";
    ITerminaltxnCountry["LESOTHO_LSO"] = "LSO";
    ITerminaltxnCountry["LITHUANIA_LTU"] = "LTU";
    ITerminaltxnCountry["LUXEMBOURG_LUX"] = "LUX";
    ITerminaltxnCountry["LATVIA_LVA"] = "LVA";
    ITerminaltxnCountry["MACAO_MAC"] = "MAC";
    ITerminaltxnCountry["SAINT_MARTIN_FRENCH_PART_MAF"] = "MAF";
    ITerminaltxnCountry["MOROCCO_MAR"] = "MAR";
    ITerminaltxnCountry["MONACO_MCO"] = "MCO";
    ITerminaltxnCountry["MOLDOVA_REPUBLIC_OF_MDA"] = "MDA";
    ITerminaltxnCountry["MADAGASCAR_MDG"] = "MDG";
    ITerminaltxnCountry["MALDIVES_MDV"] = "MDV";
    ITerminaltxnCountry["MEXICO_MEX"] = "MEX";
    ITerminaltxnCountry["MARSHALL_ISLANDS_MHL"] = "MHL";
    ITerminaltxnCountry["MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF_MKD"] = "MKD";
    ITerminaltxnCountry["MALI_MLI"] = "MLI";
    ITerminaltxnCountry["MALTA_MLT"] = "MLT";
    ITerminaltxnCountry["MYANMAR_MMR"] = "MMR";
    ITerminaltxnCountry["MONTENEGRO_MNE"] = "MNE";
    ITerminaltxnCountry["MONGOLIA_MNG"] = "MNG";
    ITerminaltxnCountry["NORTHERN_MARIANA_ISLANDS_MNP"] = "MNP";
    ITerminaltxnCountry["MOZAMBIQUE_MOZ"] = "MOZ";
    ITerminaltxnCountry["MAURITANIA_MRT"] = "MRT";
    ITerminaltxnCountry["MONTSERRAT_MSR"] = "MSR";
    ITerminaltxnCountry["MARTINIQUE_MTQ"] = "MTQ";
    ITerminaltxnCountry["MAURITIUS_MUS"] = "MUS";
    ITerminaltxnCountry["MALAWI_MWI"] = "MWI";
    ITerminaltxnCountry["MALAYSIA_MYS"] = "MYS";
    ITerminaltxnCountry["MAYOTTE_MYT"] = "MYT";
    ITerminaltxnCountry["NAMIBIA_NAM"] = "NAM";
    ITerminaltxnCountry["NEW_CALEDONIA_NCL"] = "NCL";
    ITerminaltxnCountry["NIGER_NER"] = "NER";
    ITerminaltxnCountry["NORFOLK_ISLAND_NFK"] = "NFK";
    ITerminaltxnCountry["NIGERIA_NGA"] = "NGA";
    ITerminaltxnCountry["NICARAGUA_NIC"] = "NIC";
    ITerminaltxnCountry["NIUE_NIU"] = "NIU";
    ITerminaltxnCountry["NETHERLANDS_NLD"] = "NLD";
    ITerminaltxnCountry["NORWAY_NOR"] = "NOR";
    ITerminaltxnCountry["NEPAL_NPL"] = "NPL";
    ITerminaltxnCountry["NAURU_NRU"] = "NRU";
    ITerminaltxnCountry["NEW_ZEALAND_NZL"] = "NZL";
    ITerminaltxnCountry["OMAN_OMN"] = "OMN";
    ITerminaltxnCountry["PAKISTAN_PAK"] = "PAK";
    ITerminaltxnCountry["PANAMA_PAN"] = "PAN";
    ITerminaltxnCountry["PITCAIRN_PCN"] = "PCN";
    ITerminaltxnCountry["PERU_PER"] = "PER";
    ITerminaltxnCountry["PHILIPPINES_PHL"] = "PHL";
    ITerminaltxnCountry["PALAU_PLW"] = "PLW";
    ITerminaltxnCountry["PAPUA_NEW_GUINEA_PNG"] = "PNG";
    ITerminaltxnCountry["POLAND_POL"] = "POL";
    ITerminaltxnCountry["PUERTO_RICO_PRI"] = "PRI";
    ITerminaltxnCountry["KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF_PRK"] = "PRK";
    ITerminaltxnCountry["PORTUGAL_PRT"] = "PRT";
    ITerminaltxnCountry["PARAGUAY_PRY"] = "PRY";
    ITerminaltxnCountry["PALESTINE_STATE_OF_PSE"] = "PSE";
    ITerminaltxnCountry["FRENCH_POLYNESIA_PYF"] = "PYF";
    ITerminaltxnCountry["QATAR_QAT"] = "QAT";
    ITerminaltxnCountry["RUNION_REU"] = "REU";
    ITerminaltxnCountry["ROMANIA_ROU"] = "ROU";
    ITerminaltxnCountry["RUSSIAN_FEDERATION_RUS"] = "RUS";
    ITerminaltxnCountry["RWANDA_RWA"] = "RWA";
    ITerminaltxnCountry["SAUDI_ARABIA_SAU"] = "SAU";
    ITerminaltxnCountry["SUDAN_SDN"] = "SDN";
    ITerminaltxnCountry["SENEGAL_SEN"] = "SEN";
    ITerminaltxnCountry["SINGAPORE_SGP"] = "SGP";
    ITerminaltxnCountry["SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS_SGS"] = "SGS";
    ITerminaltxnCountry["SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA_SHN"] = "SHN";
    ITerminaltxnCountry["SVALBARD_AND_JAN_MAYEN_SJM"] = "SJM";
    ITerminaltxnCountry["SOLOMON_ISLANDS_SLB"] = "SLB";
    ITerminaltxnCountry["SIERRA_LEONE_SLE"] = "SLE";
    ITerminaltxnCountry["EL_SALVADOR_SLV"] = "SLV";
    ITerminaltxnCountry["SAN_MARINO_SMR"] = "SMR";
    ITerminaltxnCountry["SOMALIA_SOM"] = "SOM";
    ITerminaltxnCountry["SAINT_PIERRE_AND_MIQUELON_SPM"] = "SPM";
    ITerminaltxnCountry["SERBIA_SRB"] = "SRB";
    ITerminaltxnCountry["SOUTH_SUDAN_SSD"] = "SSD";
    ITerminaltxnCountry["SAO_TOME_AND_PRINCIPE_STP"] = "STP";
    ITerminaltxnCountry["SURINAME_SUR"] = "SUR";
    ITerminaltxnCountry["SLOVAKIA_SVK"] = "SVK";
    ITerminaltxnCountry["SLOVENIA_SVN"] = "SVN";
    ITerminaltxnCountry["SWEDEN_SWE"] = "SWE";
    ITerminaltxnCountry["SWAZILAND_SWZ"] = "SWZ";
    ITerminaltxnCountry["SINT_MAARTEN_DUTCH_PART_SXM"] = "SXM";
    ITerminaltxnCountry["SEYCHELLES_SYC"] = "SYC";
    ITerminaltxnCountry["SYRIAN_ARAB_REPUBLIC_SYR"] = "SYR";
    ITerminaltxnCountry["TURKS_AND_CAICOS_ISLANDS_TCA"] = "TCA";
    ITerminaltxnCountry["CHAD_TCD"] = "TCD";
    ITerminaltxnCountry["TOGO_TGO"] = "TGO";
    ITerminaltxnCountry["THAILAND_THA"] = "THA";
    ITerminaltxnCountry["TAJIKISTAN_TJK"] = "TJK";
    ITerminaltxnCountry["TOKELAU_TKL"] = "TKL";
    ITerminaltxnCountry["TURKMENISTAN_TKM"] = "TKM";
    ITerminaltxnCountry["TIMORLESTE_TLS"] = "TLS";
    ITerminaltxnCountry["TONGA_TON"] = "TON";
    ITerminaltxnCountry["TRINIDAD_AND_TOBAGO_TTO"] = "TTO";
    ITerminaltxnCountry["TUNISIA_TUN"] = "TUN";
    ITerminaltxnCountry["TURKEY_TUR"] = "TUR";
    ITerminaltxnCountry["TUVALU_TUV"] = "TUV";
    ITerminaltxnCountry["TAIWAN_PROVINCE_OF_CHINA_TWN"] = "TWN";
    ITerminaltxnCountry["TANZANIA_UNITED_REPUBLIC_OF_TZA"] = "TZA";
    ITerminaltxnCountry["UGANDA_UGA"] = "UGA";
    ITerminaltxnCountry["UKRAINE_UKR"] = "UKR";
    ITerminaltxnCountry["UNITED_STATES_MINOR_OUTLYING_ISLANDS_UMI"] = "UMI";
    ITerminaltxnCountry["URUGUAY_URY"] = "URY";
    ITerminaltxnCountry["UNITED_STATES_USA"] = "USA";
    ITerminaltxnCountry["UZBEKISTAN_UZB"] = "UZB";
    ITerminaltxnCountry["HOLY_SEE_VATICAN_CITY_STATE_VAT"] = "VAT";
    ITerminaltxnCountry["SAINT_VINCENT_AND_THE_GRENADINES_VCT"] = "VCT";
    ITerminaltxnCountry["VENEZUELA_BOLIVARIAN_REPUBLIC_OF_VEN"] = "VEN";
    ITerminaltxnCountry["VIRGIN_ISLANDS_BRITISH_VGB"] = "VGB";
    ITerminaltxnCountry["VIRGIN_ISLANDS_U_VIR"] = "VIR";
    ITerminaltxnCountry["VIET_NAM_VNM"] = "VNM";
    ITerminaltxnCountry["VANUATU_VUT"] = "VUT";
    ITerminaltxnCountry["WALLIS_AND_FUTUNA_WLF"] = "WLF";
    ITerminaltxnCountry["SAMOA_WSM"] = "WSM";
    ITerminaltxnCountry["YEMEN_YEM"] = "YEM";
    ITerminaltxnCountry["SOUTH_AFRICA_ZAF"] = "ZAF";
    ITerminaltxnCountry["ZAMBIA_ZMB"] = "ZMB";
    ITerminaltxnCountry["ZIMBABWE_ZWE"] = "ZWE";
})(ITerminaltxnCountry = exports.ITerminaltxnCountry || (exports.ITerminaltxnCountry = {}));
var ITerminaltxnStatus;
(function (ITerminaltxnStatus) {
    ITerminaltxnStatus[ITerminaltxnStatus["PENDING_0"] = 0] = "PENDING_0";
    ITerminaltxnStatus[ITerminaltxnStatus["APPROVED_1"] = 1] = "APPROVED_1";
    ITerminaltxnStatus[ITerminaltxnStatus["FAILED_2"] = 2] = "FAILED_2";
    ITerminaltxnStatus[ITerminaltxnStatus["CAPTURED_3"] = 3] = "CAPTURED_3";
    ITerminaltxnStatus[ITerminaltxnStatus["SETTLED_4"] = 4] = "SETTLED_4";
    ITerminaltxnStatus[ITerminaltxnStatus["RETURNED_5"] = 5] = "RETURNED_5";
})(ITerminaltxnStatus = exports.ITerminaltxnStatus || (exports.ITerminaltxnStatus = {}));
var ITerminaltxnReserved;
(function (ITerminaltxnReserved) {
    ITerminaltxnReserved[ITerminaltxnReserved["NO_RESERVE_0"] = 0] = "NO_RESERVE_0";
    ITerminaltxnReserved[ITerminaltxnReserved["TRANSACTION_PROCESSING_WITHHELD_1"] = 1] = "TRANSACTION_PROCESSING_WITHHELD_1";
    ITerminaltxnReserved[ITerminaltxnReserved["TRANSACTION_CAPTURE_WITHHELD_PENDING_MANUAL_REVIEW_3"] = 3] = "TRANSACTION_CAPTURE_WITHHELD_PENDING_MANUAL_REVIEW_3";
    ITerminaltxnReserved[ITerminaltxnReserved["MOVE_ALL_FUNDS_FROM_THIS_TRANSACTION_INTO_A_RESERVE_4"] = 4] = "MOVE_ALL_FUNDS_FROM_THIS_TRANSACTION_INTO_A_RESERVE_4";
    ITerminaltxnReserved[ITerminaltxnReserved["BLOCK_CURRENT_ACTIVITY_NO_CHANGE_FOR_MERCHANT_5"] = 5] = "BLOCK_CURRENT_ACTIVITY_NO_CHANGE_FOR_MERCHANT_5";
    ITerminaltxnReserved[ITerminaltxnReserved["DEFAULT_6"] = 6] = "DEFAULT_6";
    ITerminaltxnReserved[ITerminaltxnReserved["DEFAULT_7"] = 7] = "DEFAULT_7";
})(ITerminaltxnReserved = exports.ITerminaltxnReserved || (exports.ITerminaltxnReserved = {}));
var ITerminaltxnInactive;
(function (ITerminaltxnInactive) {
    ITerminaltxnInactive[ITerminaltxnInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    ITerminaltxnInactive[ITerminaltxnInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(ITerminaltxnInactive = exports.ITerminaltxnInactive || (exports.ITerminaltxnInactive = {}));
var ITerminaltxnFrozen;
(function (ITerminaltxnFrozen) {
    ITerminaltxnFrozen[ITerminaltxnFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    ITerminaltxnFrozen[ITerminaltxnFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(ITerminaltxnFrozen = exports.ITerminaltxnFrozen || (exports.ITerminaltxnFrozen = {}));
var ITerminaltxnPaymentmethod;
(function (ITerminaltxnPaymentmethod) {
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["AMERICAN_EXPRESS_1"] = 1] = "AMERICAN_EXPRESS_1";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["VISA_2"] = 2] = "VISA_2";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["MASTERCARD_3"] = 3] = "MASTERCARD_3";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["DINERS_CLUB_4"] = 4] = "DINERS_CLUB_4";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["DISCOVER_5"] = 5] = "DISCOVER_5";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["PAYPAL_6"] = 6] = "PAYPAL_6";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["DEBIT_CARD_7"] = 7] = "DEBIT_CARD_7";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["CHECKING_ACCOUNT_8"] = 8] = "CHECKING_ACCOUNT_8";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["SAVINGS_ACCOUNT_9"] = 9] = "SAVINGS_ACCOUNT_9";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["CORPORATE_CHECKING_ACCOUNT_10"] = 10] = "CORPORATE_CHECKING_ACCOUNT_10";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["CORPORATE_SAVINGS_ACCOUNT_11"] = 11] = "CORPORATE_SAVINGS_ACCOUNT_11";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["GIFT_CARD_12"] = 12] = "GIFT_CARD_12";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["EBT_CARD_13"] = 13] = "EBT_CARD_13";
    ITerminaltxnPaymentmethod[ITerminaltxnPaymentmethod["WIC_CARD_14"] = 14] = "WIC_CARD_14";
})(ITerminaltxnPaymentmethod = exports.ITerminaltxnPaymentmethod || (exports.ITerminaltxnPaymentmethod = {}));
